var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.component)?_c(_vm.component,_vm._b({ref:"dynam",tag:"component",on:{"AfterRendering":_vm.AfterRendering,"childevent":_vm.childevent,"update":_vm.update}},'component',_vm.comData,false),[_vm._l((_vm.$slots),function(val,key){return _c('template',{slot:key},[_vm._t(key)],2)})],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a6e7d0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vueformmaking/DynamicLink.vue
// module id = null
// module chunks = 